import React from 'react';

export const OutboundCallSettings = ({ config, agents, onChange, isDarkMode }) => {
  const fieldClass = `w-full min-w-0 px-3 py-2 rounded-lg border text-sm focus:outline-none focus:border-teal-400/50 ${isDarkMode ? 'bg-white/5 border-white/10 text-white' : 'bg-gray-50 border-gray-200 text-gray-900'}`;
  return (
    <div className="space-y-5 min-w-0" data-testid="outbound-call-settings">
      <div className="space-y-2">
        <label htmlFor="outbound-voice-agent" className="block text-sm font-medium" data-testid="outbound-voice-agent-label">Voice Agent for Calls</label>
        <select id="outbound-voice-agent" value={config.outbound_voice_agent_id || ''}
          onChange={e => onChange('outbound_voice_agent_id', e.target.value)}
          className={fieldClass} data-testid="outbound-voice-agent-select">
          <option value="">Select a voice agent...</option>
          {config.outbound_voice_agent_id && !agents.some(agent => agent.agent_id === config.outbound_voice_agent_id) && (
            <option value={config.outbound_voice_agent_id}>Saved agent (currently unavailable)</option>
          )}
          {agents.map(agent => <option key={agent.agent_id} value={agent.agent_id}>{agent.name}</option>)}
        </select>
      </div>
      <div className="space-y-2">
        <label htmlFor="outbound-call-description" className="block text-sm font-medium" data-testid="outbound-call-description-label">Trigger Description</label>
        <textarea id="outbound-call-description" value={config.outbound_call_description || ''}
          onChange={e => onChange('outbound_call_description', e.target.value)} rows={4}
          className={`${fieldClass} resize-y`} data-testid="outbound-call-description"
          placeholder="When the contact explicitly asks to be called or requests a phone call." />
      </div>
    </div>
  );
};